import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ทำพินัยกรรมในไทย — ทรัพย์สินไทยสำหรับชาวต่างชาติและคู่สมรส","metaTitle":"พินัยกรรมไทย (Thai Will) — ยกทรัพย์คอนโด ที่ดิน บัญชี | NYC Legal","metaDesc":"ทำพินัยกรรมทรัพย์สินในไทย ครอบคลุมคอนโด ที่ดิน (สิทธิ์เก็บกิน) บัญชี หุ้น รวมถึง Living Will ตาม พ.ร.บ.สุขภา — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน"},"en":{"h1":"Thai Will & Testament — Estate Planning for Foreigners in Thailand","metaTitle":"Thai Will for Foreigners — Condo, Land, Bank, Living Will | NYC Legal","metaDesc":"Bilingual Thai Will covering condos, land (usufruct), Thai bank accounts, shares, and Living Will under H — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/en/legal/wills-testament")({
  head: () => {
    const url = `${SEO_SITE}/en/legal/wills-testament`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/legal/wills-testament", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/legal/wills-testament", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/legal/wills-testament", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/legal/wills-testament", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/legal/wills-testament", "/en/legal/wills-testament")],
    };
  },
  component: () => <SubServicePage slug="legal/wills-testament" locale="en" />,
});
